import React from "react";

import {Grid, Alert, Card, Button, Typography} from "@mui/material";

import errors from "../assets/error/errors.png";
import {useTranslation} from "react-i18next";

// `resetErrorBoundary`, fourni par react-error-boundary, n'est volontairement pas déclaré : le
// bouton recharge la page entière plutôt que de seulement remonter l'arbre React.
interface ErrorBoundaryOverlayProps {
  // `unknown` et non `Error` : c'est ce que react-error-boundary 6 passe désormais, à juste titre
  // puisqu'on peut lancer n'importe quelle valeur en JavaScript. La 4 promettait un `Error`, ce
  // qu'elle ne pouvait pas garantir.
  error: unknown;
}

const ErrorBoundaryOverlay: React.FC<ErrorBoundaryOverlayProps> = ({error}) => {
  const {t} = useTranslation();
  const reloadCurrentPage = () => {
    window.location.reload();
  };

  return (
    <Card className="search-card">
      <Grid
        container
        sx={{
          justifyContent: "center",
          backgroundColor: "transparent",
        }}>
        <Grid size={12}>
          <Typography variant="h4" gutterBottom style={{textAlign: "center", marginTop: "50px"}}>
            {t("errorBoundary.title")}
          </Typography>
        </Grid>
        <Grid
          style={{marginTop: "30px"}}
          size={{
            xs: 12,
            md: 8,
          }}>
          <Typography variant="body1">
            {t("errorBoundary.whileWeFix")}
            <ul>
              <li>{t("errorBoundary.refresh")}</li>
              <li>{t("errorBoundary.home")}</li>
              <li>{t("errorBoundary.support")}</li>
            </ul>
          </Typography>
        </Grid>
        <Grid
          style={{marginTop: "30px"}}
          size={{
            xs: 12,
            md: 4,
          }}>
          <Typography variant="body1">{t("errorBoundary.technicalError")}</Typography>
          <Alert variant="outlined" style={{marginTop: "10px"}} severity="error">
            {error instanceof Error ? error.message : String(error)}
          </Alert>
        </Grid>
        <Grid style={{textAlign: "center"}} size={12}>
          <Button
            style={{marginBottom: "40px", marginTop: "50px"}}
            variant="outlined"
            color="primary"
            onClick={reloadCurrentPage}>
            {t("errorBoundary.reload")}
          </Button>
        </Grid>
        <Grid style={{textAlign: "center"}} size={12}>
          <img alt={t("errorBoundary.imageAlt")} width="500" src={errors} />
        </Grid>
      </Grid>
    </Card>
  );
};

export default ErrorBoundaryOverlay;
